"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeAvatarUrl = exports.updateFriendsInfo = exports.refreshFriends = exports.acceptFriendRequest = exports.declineFriendRequest = exports.sendFriendRequest = exports.resetFriendError = exports.friendError = exports.clearMetaError = exports.forgottenPassword = exports.forgottenPasswordFailure = exports.forgottenPasswordSuccess = exports.resetPassword = exports.logoutUser = exports.registerUser = exports.registerFailure = exports.registerSuccess = exports.loginUser = exports.loginFailure = exports.loginSuccess = exports.loadingRequest = exports.feedbackSubmitted = exports.submitFeedback = exports.initialiseGame = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _MetaActionTypes = require("../constants/action-types/MetaActionTypes");

var metaTypes = _interopRequireWildcard(_MetaActionTypes);

var _requests = require("../libs/utils/requests");

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var TOKEN_ID = "soc-token"; //===============
// meta actions
//===============
//TODO: if we hook it up properly, this could be a good way of showing a loading bar/screen whilst loading
//TODO: however, the problem is the event is currently triggered only on socket call... it is hardcoded into initial state for avatar building

var initialiseGame = exports.initialiseGame = function initialiseGame() {
  return {
    type: metaTypes.INITIALISE_GAME
  };
};

var submitFeedback = exports.submitFeedback = function submitFeedback(roomId, playerName, netPromoterScore, enjoymentScore) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api; //TODO: Need to get roomId too
    //Do we put this in the state..?

    var fetchOptions = {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({
        netPromoterScore: netPromoterScore,
        enjoymentScore: enjoymentScore,
        playerName: playerName,
        roomId: roomId
      }),
      headers: {
        "Content-Type": "application/json"
      }
    };
    return (0, _requests.sendRequest)({
      destination: api.feedback,
      options: fetchOptions
    }).then(function () {
      return dispatch(feedbackSubmitted());
    });
  };
}; //TODO: Not the nicest but quick-fix thing for now
// e.g. upon rejoining a game, or doing a new character building
// this will be reset to false, so they will still be prompted for NPS


var feedbackSubmitted = exports.feedbackSubmitted = function feedbackSubmitted() {
  return {
    type: metaTypes.FEEDBACK_SUBMITTED
  };
};

var loadingRequest = exports.loadingRequest = function loadingRequest() {
  return {
    type: metaTypes.LOADING_REQUEST
  };
};

var loginSuccess = exports.loginSuccess = function loginSuccess(_ref2) {
  var token = _ref2.token,
      user = _ref2.user;
  return {
    type: metaTypes.LOGIN_SUCCESS,
    payload: _extends({
      isFetching: false,
      isAuthenticated: true,
      token: token
    }, user)
  };
};

var loginFailure = exports.loginFailure = function loginFailure(message) {
  return {
    type: metaTypes.LOGIN_FAILURE,
    payload: {
      isFetching: false,
      isAuthenticated: false,
      metaError: message
    }
  };
};

var loginUser = exports.loginUser = function loginUser(credentials) {
  var fetchOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(credentials)
  };
  return function (dispatch) {
    dispatch(loadingRequest());
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.login,
      options: fetchOptions
    }).then(function (response) {
      if (!response.payload.token) {
        dispatch(loginFailure("Invalid username or password"));
        return Promise.reject(response);
      }

      localStorage.setItem(TOKEN_ID, response.payload.token);
      dispatch(loginSuccess(response.payload));
    }).catch(function () {
      return dispatch(loginFailure("Invalid username or password"));
    });
  };
};

var registerSuccess = exports.registerSuccess = function registerSuccess(_ref3) {
  var token = _ref3.token,
      user = _ref3.user;
  return {
    type: metaTypes.REGISTER_SUCCESS,
    payload: _extends({
      isFetching: false,
      isAuthenticated: true,
      token: token
    }, user)
  };
};

var registerFailure = exports.registerFailure = function registerFailure(message) {
  return {
    type: metaTypes.REGISTER_FAILURE,
    payload: {
      isFetching: false,
      isAuthenticated: false,
      metaError: message
    }
  };
};

var registerUser = exports.registerUser = function registerUser(credentials) {
  var fetchOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(credentials)
  };
  return function (dispatch) {
    dispatch(loadingRequest());
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.users,
      options: fetchOptions
    }).then(function (response) {
      if (!response.payload.token) {
        dispatch(registerFailure(response.message));
        return Promise.reject(response);
      }

      localStorage.setItem(TOKEN_ID, response.payload.token);
      dispatch(registerSuccess(response.payload));
    }).catch(function (err) {
      return dispatch(registerFailure(err.message));
    });
  };
};

var logoutSuccess = function logoutSuccess() {
  return {
    type: metaTypes.LOGOUT_SUCCESS,
    isFetching: false,
    isAuthenticated: false
  };
};

var logoutFailure = function logoutFailure(message) {
  return {
    type: metaTypes.LOGOUT_FAILURE,
    payload: {
      isFetching: false,
      metaError: message
    }
  };
};

var logoutUser = exports.logoutUser = function logoutUser() {
  return function (dispatch) {
    try {
      dispatch(loadingRequest());
      localStorage.removeItem(TOKEN_ID);
      dispatch(logoutSuccess());
    } catch (error) {
      dispatch(logoutFailure(error.message));
    }
  };
};

var resetPasswordSuccess = function resetPasswordSuccess() {
  return {
    type: metaTypes.PASSWORD_RESET_SUCCESS,
    payload: {
      isFetching: false,
      isAuthenticated: false,
      resetSuccess: true
    }
  };
};

var resetPasswordFailure = function resetPasswordFailure(message) {
  return {
    type: metaTypes.PASSWORD_RESET_FAILURE,
    payload: {
      isFetching: false,
      isAuthenticated: false,
      metaError: message
    }
  };
};

var resetPassword = exports.resetPassword = function resetPassword(creds) {
  var fetchOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(creds)
  };
  return function (dispatch) {
    dispatch(loadingRequest());
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.passwordResetEntry,
      options: fetchOptions
    }).then(function (response) {
      if (!response.payload.ok) {
        dispatch(resetPasswordFailure(response.message));
        return Promise.reject(response);
      }

      dispatch(resetPasswordSuccess(response.payload));
    }).catch(function (err) {
      return dispatch(resetPasswordFailure(err.message));
    });
  };
};

var forgottenPasswordSuccess = exports.forgottenPasswordSuccess = function forgottenPasswordSuccess(_ref4) {
  var message = _ref4.message;
  return {
    type: metaTypes.FORGOTTEN_PASSWORD_SUCCESS,
    payload: {
      isFetching: false,
      isAuthenticated: false,
      message: message
    }
  };
};

var forgottenPasswordFailure = exports.forgottenPasswordFailure = function forgottenPasswordFailure(message) {
  return {
    type: metaTypes.FORGOTTEN_PASSWORD_FAILURE,
    payload: {
      isFetching: false,
      isAuthenticated: false,
      metaError: message
    }
  };
}; //TODO: finish implementation of this
//TODO: all the sub methods need to be implemented properly for each of the main actions in here


var forgottenPassword = exports.forgottenPassword = function forgottenPassword(email) {
  var fetchOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      email: email
    })
  };
  return function (dispatch) {
    dispatch(loadingRequest());
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.passwordReset,
      options: fetchOptions
    }).then(function (response) {
      if (!response.payload.success) {
        dispatch(forgottenPasswordFailure(response.message));
        return Promise.reject(response);
      }

      dispatch(forgottenPasswordSuccess(response));
    }).catch(function (err) {
      return dispatch(forgottenPasswordFailure(err.message));
    });
  };
};

var clearMetaError = exports.clearMetaError = function clearMetaError() {
  return {
    type: metaTypes.CLEAR_META_ERROR
  };
};
/* FRIENDS SECTION */


var friendError = exports.friendError = function friendError(_ref5) {
  var message = _ref5.message;
  return {
    type: metaTypes.FRIEND_ERROR,
    payload: {
      message: message
    }
  };
};

var resetFriendError = exports.resetFriendError = function resetFriendError() {
  return {
    type: metaTypes.RESET_FRIEND_ERROR
  };
};

var sendFriendRequest = exports.sendFriendRequest = function sendFriendRequest(_ref6) {
  var token = _ref6.token,
      name = _ref6.name;
  var fetchOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  };
  return function (dispatch) {
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.friends + "/" + name,
      options: fetchOptions
    }).then(function (response) {
      if (response.error) {
        return dispatch(friendError({
          message: response.message
        }));
      }

      return dispatch(refreshFriends({
        token: token
      }));
    }).catch(function (err) {
      return console.log(err);
    });
  };
};

var declineFriendRequest = exports.declineFriendRequest = function declineFriendRequest(_ref7) {
  var token = _ref7.token,
      name = _ref7.name;
  var fetchOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  };
  return function (dispatch) {
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.friends + "/" + name + "/decline",
      options: fetchOptions
    }).then(function () {
      dispatch(refreshFriends({
        token: token
      }));
    }).catch(function (err) {
      return console.log(err);
    });
  };
};

var acceptFriendRequest = exports.acceptFriendRequest = function acceptFriendRequest(_ref8) {
  var token = _ref8.token,
      name = _ref8.name;
  var fetchOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  };
  return function (dispatch) {
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.friends + "/" + name + "/accept",
      options: fetchOptions
    }).then(function () {
      dispatch(refreshFriends({
        token: token
      }));
    }).catch(function (err) {
      return console.log(err);
    });
  };
};

var refreshFriends = exports.refreshFriends = function refreshFriends(_ref9) {
  var token = _ref9.token;
  var fetchOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  };
  return function (dispatch) {
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.friends,
      options: fetchOptions
    }).then(function (_ref10) {
      var payload = _ref10.payload;
      dispatch(updateFriendsInfo(payload));
    }).catch(function (err) {
      return console.log(err);
    });
  };
};

var updateFriendsInfo = exports.updateFriendsInfo = function updateFriendsInfo(payload) {
  var friends = payload.friends,
      requestsSent = payload.requestsSent,
      requestsReceived = payload.requestsReceived;
  var updated = {
    friends: friends
  };

  if (requestsSent) {
    updated.sent = requestsSent;
  }

  if (requestsReceived) {
    updated.requests = requestsReceived;
  }

  return {
    type: metaTypes.UPDATE_FRIENDS_INFO,
    payload: updated
  };
};

var storeAvatarUrl = exports.storeAvatarUrl = function storeAvatarUrl(_ref11) {
  var url = _ref11.url;
  return {
    type: metaTypes.STORE_AVATAR_URL_SUCCESS,
    payload: {
      url: url
    }
  };
};